import { connect } from 'react-redux'
import { H4, Subtitle2 } from '../../cdl-react-components/components'
import { updateSearchParameters } from '../../../store/actions/search'
import { SearchParameter } from '../../../utilities/models'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { graphqlFetch } from '../../cdl-react-components/utilities'

// const analyses = [
//     { prop: 'monthly_spuds', title: 'Spud Analysis', value: 'Monthly Spud Analysis', image: '/static/images/monthly-spuds-icon.svg' },
//     { prop: 'monthly_land_sale_outlook', title: 'Land Sale Outlook', value: 'Monthly Land Sale Outlook', image: '/static/images/monthly-land-sale-outlook-icon.svg' },
//     { prop: 'monthly_montney_duvernay_update', title: 'Montney & Duvernay Completions', value: 'Monthly Montney & Duvernay Completions Update', image: '/static/images/monthly-montney-duvernay-completions-icon.svg' },
//     { prop: 'monthly_production_analysis', title: 'Production Analysis', value: 'Monthly Production Analysis', image: '/static/images/quarterly-production-icon.svg' },
//     { prop: 'quarterly_land_analysis', title: 'Crown Land Sale Analysis', value: 'Quarterly Crown Land Sale Analysis', image: '/static/images/quarterly-land-icon.svg' },
//     { prop: 'quarterly_completions_analysis', title: 'Completions Analysis', value: 'Quarterly Completions Analysis', image: '/static/images/quarterly-completions-icon.svg' }
// ]

const EPAnalysis = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [analyses, setAnalyses] = useState()
    
    useEffect(() => {
        (async () => {
            const query = `
                query {
                    epTypes(
                        where: { displayOnHomePage: { eq: true } }
                        order: { displayOrder: ASC, displayName: ASC }
                    ) {
                        name
                        displayOnHomePage
                        displayOrder
                        displayName
                        linkPath
                        iconImage
                    }
                }`

            const res = await graphqlFetch('wcms3', query)
            setAnalyses(res.data?.epTypes)

            // TODO: should have som kind of error state here
        })()
    }, [])

    const handleClick = (analysis) => () => {
        let url = analysis.linkPath

        // http address
        if (url.startsWith('http')) {
            window.open(url)
            return
        }

        // Yes, this method eliminates all query params except 'query' but honestly can't think of a situation where that's relevant.
        if (url.includes('?') && url.includes('query='))
        {
            // Navigate first, otherwise the updateSearchParameters dispatch seems to mess with the navigation - rrogers
            navigate(url.substring(0, url.indexOf('?')))            
            
            // > Example query string: /article/5294?query=[{"name":"epType","value":"Monthly%20Spud%20Analysis"}]
            const searchQuery = 
                url.substring(url.indexOf('?') + 1)
                    .split(';')
                    .reduce((acc, x) => [...acc, x.split('=')], [])
                    .find(x => x[0] === 'query')

            if (searchQuery) {
                const searchParams = 
                    JSON.parse(searchQuery[1])
                        .map(x => new SearchParameter(x.name, decodeURI(x.value)))

                dispatch(updateSearchParameters(searchParams))
            }
        }
        else {
            if (url.indexOf('?') > -1)
                url = url.substring(0, url.indexOf('?'))

            if (!url)
                url = window.location.pathname

            navigate(url)
        }
    }

    const renderAnalysis = (analysis) => {
        const displayName = analysis.displayName ?? analysis.name
        const prop = displayName.toLowerCase().replaceAll(' ', '_')

        let link = analysis.linkPath
        if (analysis.linkPath.startsWith("?"))
            link = window.location.pathname + link

        return (
            <div onClick={handleClick(analysis)}
                className="ep-analysis__article"
                key={'ep-analysis__article--' + prop} title={displayName}>
                <img src={'https://webfiles.canadiandiscovery.com/' + analysis.iconImage} alt={prop + '_icon'} />
                <div className="ep-analysis__article__content">
                    <Subtitle2>{displayName}</Subtitle2>
                </div>
            </div>)       
    }    

    return !!analyses ? (
        <div className="ep-analysis">
            <H4>Most Recent E&amp;P Analyses</H4>
            <div className="ep-analysis__articles">
                {analyses.map(renderAnalysis)}
            </div>
        </div>
    ) : null
}

const mapDispatchToProps = (dispatch) => ({ 
    updateSearchParameters: (paramters) => dispatch(updateSearchParameters(paramters))
})

export default connect(null, mapDispatchToProps)(EPAnalysis)